/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum NoteCategory {
  Tracking = "tracking",
  General = "general",
  Booking = "booking",
  Quoting = "quoting",
  Billing = "billing",
  Claim = "claim",
  BannerMessage = "banner_message",
}

export function instanceOfNoteCategory(value: any): boolean {
  for (const key in NoteCategory) {
    if (Object.prototype.hasOwnProperty.call(NoteCategory, key)) {
      if (NoteCategory[key as keyof typeof NoteCategory] === value) {
        return true;
      }
    }
  }
  return false;
}

export function NoteCategoryFromJSON(json: any): NoteCategory {
  return NoteCategoryFromJSONTyped(json, false);
}

export function NoteCategoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): NoteCategory {
  return json as NoteCategory;
}

export function NoteCategoryToJSON(value?: NoteCategory | null): any {
  return value as any;
}

export function NoteCategoryToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): NoteCategory {
  return value as NoteCategory;
}
